module.exports = __webpack_public_path__ + "static/media/about.54312242.svg";